var _g, _rect, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 5.375,
    y: 0.044,
    width: 35.167,
    height: 47.956
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M18.934,29.791c-0.179-0.133-0.425-0.141-0.587-0.004 c-1.057,0.746-2.248,1.204-3.485,1.516l0.083-14.565c1.207,0.329,2.373,0.808,3.401,1.577c0.162,0.129,0.416,0.129,0.595,0 c0.167-0.133,0.247-0.367,0.163-0.57L12.82,0.37c-0.07-0.196-0.245-0.325-0.455-0.325c-0.218-0.008-0.396,0.129-0.472,0.317 L5.407,17.656c-0.07,0.208-0.011,0.442,0.164,0.566c0.087,0.07,0.199,0.104,0.295,0.104c0.107,0,0.212-0.025,0.291-0.092 c1.07-0.745,2.265-1.221,3.498-1.536L9.57,31.281c-1.211-0.315-2.377-0.79-3.405-1.552c-0.163-0.133-0.413-0.133-0.595,0 c-0.168,0.125-0.246,0.357-0.164,0.563l6.287,17.377c0.062,0.197,0.245,0.322,0.453,0.331c0.208,0,0.399-0.13,0.471-0.325 l6.477-17.317C19.165,30.153,19.108,29.925,18.934,29.791"
  }))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.375,
    y: 0.954,
    fill: "none",
    width: 37,
    height: 45
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 5.377,
    y: 0.12,
    width: 39.33,
    height: 47.834
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_4_)",
    fill: "#E73537",
    points: "43.876,30.705 39.053,25.884 33.514,31.425 27.975,25.884  23.148,30.705 28.688,36.248 23.148,41.788 27.975,46.612 33.514,41.073 39.053,46.612 43.876,41.788 38.337,36.248  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUpDown);
export default __webpack_public_path__ + "static/media/noUpDown.179f105ac6b68a8b3dd5e4a1d5885236.svg";
export { ForwardRef as ReactComponent };